import { createSlice } from '@reduxjs/toolkit';

export const AreaSlice = createSlice({
  name: 'area',
  initialState: {
    areas_list: [],
    area: {},
  },
  reducers: {
    setAreasRedux: (state, { payload }) => {
      state.areas_list = payload;
    },
    storeAreaRedux: (state, { payload }) => {
      state.area = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setAreasRedux, storeAreaRedux } = AreaSlice.actions;
